module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account-menu"
  }, [_c('ul', {
    staticClass: "dropdown-content"
  }, [_c('li', [_c('div', {
    staticClass: "account-button"
  }, [_c('a', {
    attrs: {
      "id": "profile"
    },
    on: {
      "click": function($event) {
        _vm.toggleAccountSettings()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('str.MyProfile')))])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "account-button"
  }, [_c('a', {
    attrs: {
      "id": "logout"
    },
    on: {
      "click": function($event) {
        _vm.Logout()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('str.Logout')))])])])]), _vm._v(" "), (_vm.modalOpen) ? _c('profilemanagement', {
    attrs: {
      "user": _vm.user,
      "service": _vm.service
    },
    on: {
      "closeModal": _vm.close
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67537574","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccountMenu.vue
// module id = 477
// module chunks = 0